import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { StoreProvider, componentDict } from '@teko-builder/base-components';

const formatDate = (date) => {
    if (!date)
        return undefined;
    return new Date(date).toISOString();
};
const validateIsVisibleComponent = ({ startTime, endTime }) => {
    const now = new Date().toISOString();
    const formatedStartTime = formatDate(startTime);
    const formatedEndTime = formatDate(endTime);
    if (formatedStartTime && now < formatedStartTime) {
        return false;
    }
    if (formatedEndTime && now >= formatedEndTime) {
        return false;
    }
    return true;
};
const renderComponent = (id, apiResponse, components, restProps) => {
    const compData = apiResponse[id];
    const { tag } = compData;
    const Comp = components[tag];
    if (!Comp) {
        console.log('Cannot found component: ' + tag);
        return null;
    }
    const props = Object.assign(Object.assign(Object.assign({}, (compData.customAttributes[tag] || {})), { commonStyle: compData.style || {}, id: compData.elementId, 'data-id': compData.elementId }), restProps);
    const getClassName = () => {
        var _a, _b;
        return clsx({
            'hidden-xs': (_a = props === null || props === void 0 ? void 0 : props.responsive) === null || _a === void 0 ? void 0 : _a.hiddenXs,
            'hidden-md': (_b = props === null || props === void 0 ? void 0 : props.responsive) === null || _b === void 0 ? void 0 : _b.hiddenMd,
        });
    };
    const isVisible = validateIsVisibleComponent(compData);
    if (!isVisible)
        return null;
    if (compData.children.length) {
        return (jsx(Comp, Object.assign({ className: getClassName() }, props, { children: compData.children.map((childId) => renderComponent(childId, apiResponse, components, restProps)) }), compData.id));
    }
    return jsx(Comp, Object.assign({ className: getClassName() }, props), compData.id);
};
const BuilderComponent = ({ content, configs, }) => {
    if (!content)
        return null;
    if (content['ROOT']) {
        return (jsx(StoreProvider, Object.assign({}, configs, { children: renderComponent('ROOT', content, componentDict, configs) })));
    }
};

export { BuilderComponent, renderComponent };
